import { render, staticRenderFns } from "./CompetenceDescriptors.vue?vue&type=template&id=d0092bb8&scoped=true"
import script from "./CompetenceDescriptors.vue?vue&type=script&lang=js"
export * from "./CompetenceDescriptors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0092bb8",
  null
  
)

export default component.exports